import { render } from "./humVideoPlayer.vue?vue&type=template&id=8a59a9fc&scoped=true"
import script from "./humVideoPlayer.vue?vue&type=script&lang=js"
export * from "./humVideoPlayer.vue?vue&type=script&lang=js"

import "./humVideoPlayer.vue?vue&type=style&index=0&id=8a59a9fc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a59a9fc"]])

export default __exports__